import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_pffy5dqdsz: FaireBrandEntity = {
  token: "b_pffy5dqdsz",
  type: "brand",
  name: "Bombshell Sweets",
  avatarUrl:
    "https://cdn.faire.com/fastly/2c8675091bcc125bdb449c808bdfac1b233050de65faa0639582d69e1f33cd9c.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/0cd3065bdd2af0f74e0803a41017e25f9f9e8a332410c419b72cc38a33c7800f.png",
  logoUrl:
    "https://cdn.faire.com/fastly/2c8675091bcc125bdb449c808bdfac1b233050de65faa0639582d69e1f33cd9c.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/0cd3065bdd2af0f74e0803a41017e25f9f9e8a332410c419b72cc38a33c7800f.png",
  location: "Hayden, ID, USA",
  minimumOrderDollars: 139,
  rating: 5,
  reviewCount: 2,
  isInsider: true,
  description:
    "Bombshell Sweets started out as a gourmet cotton candy company looking to re-invent the cotton candy industry. Our success in making amazing Cotton Candy encouraged us to look into other ways to translate our awesome flavors into other product lines as well. What makes Bombshell Sweets so unique if the perfect blending of high quality ingredients and flavors blended with nostalgia... the treats you loved as a kid updated for the adult flavor palate.  That is why we say, Bombshell Sweets: Gourmet Treats...perfected.",
  meta: {
    source: "api",
    importedAt: "2026-03-27T00:06:41.433Z",
    importedBy: "entity-db-cli",
  },
};
